import React from 'react';
import { addCommas } from 'core/utils/helpers/numbers';

function EarningCategoryRebate(props) {
  const {
    valueWithCurrency, elevation, originalValue, showRebateSuffixInOldValue,
    suffix, showRebateSuffixInElevatedNewValue, showRebateSuffixInNewValue,
  } = props;
  return (
    <span className="mn_earningCategoryRebate">
      {elevation ? (
        <>
          <span className="mn_elevationOldValue">
            {`Was ${addCommas(originalValue)}`}
            {!suffix && <span className="mn_elevationOldValueDot">.</span>}
            {showRebateSuffixInOldValue && <span className="mn_rebateSuffix">{suffix}.</span>}
          </span>
          {' '}
          <span className="mn_elevationNewValue">
            {`Now ${addCommas(valueWithCurrency)}`}
            { showRebateSuffixInElevatedNewValue && <span className="mn_rebateSuffix">{suffix}</span>}
          </span>
        </>
      ) : (
        <span className="mn_unelevatedValue">
          {addCommas(valueWithCurrency)}
          {showRebateSuffixInNewValue && <span className="mn_rebateSuffix">{suffix}</span>}
        </span>
      )}
    </span>
  );
}

export default EarningCategoryRebate;
